import React, { Component } from 'react';
import FormCreatePassword from '../../Fields/FormCreatePassword.js';
import FormInput from '../../Fields/FormInput';
import { postPassword } from '../../Api/UserActions.js';
import { getTranslation } from '../../Utilities/GetTranslation.js'
import { isEmpty } from '../../Utilities/JsonFunctions.js';

declare var globalSns;

class Password extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showValidation: false,
            txtUserPassword: ""
        };

        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChange = this.onChange.bind(this);
        this.change = this.change.bind(this);
    }

    componentWillMount() {
    }

    onChangePassword(e, password, valid) {
        this.setState({
            password: password,
            passwordvalid: valid
        })
        
    }

    onChange(e) {
        this.setState({
            [e.target.id]: e.target.value
        });         
    }

    change() {
        if (this.state.passwordvalid) {
            postPassword(this.state.txtUserPassword, this.state.password, (ok) => {
                if (ok === true) {
                    this.setState({
                        showValidation: false,
                        changererror: false,
                        showOk: true
                    });
                } else {
                    this.setState({
                        showValidation: true,
                        changererror: true,
                        showOk: false
                    });
                }
            })
        } else {
            this.setState({
                showValidation: true
            });
        }
    }

    render() {
        return (
            <div className="registration">
                <div className="EditingFormTable table">
                    {
                        (this.state.changererror) ?
                            <span className="ErrorLabel">{getTranslation("sns.webparts.password.error")}</span> : ""
                    }
                    {
                        (this.state.showOk) ?
                            <span className="SuccessLabel">{getTranslation("sns.webparts.password.changed")}</span> : ""
                    }            
                    <FormInput id="txtUserPassword" 
                        text={getTranslation("sns.webparts.password.current")}
                        required={true}
                        type="password"
                        validationText={isEmpty(this.state.txtUserPassword) ? getTranslation("basicform.erroremptyvalue"): null}
                        showValidation={this.state.showValidation}
                        value={this.state.txtUserPassword} 
                        onChange={this.onChange} />             
                    <FormCreatePassword 
                        showValidation={this.state.showValidation}
                        onChange={this.onChangePassword} />  
                    <div className="tr text-right col-md-8 button-wrapper">
                        <input type="button" className="FormButton btn btn-primary" value={getTranslation("sns.webparts.password.change")} onClick={this.change} />
                    </div>                     
                </div>
            </div>
        );  
    }
}

export default Password;


// WEBPACK FOOTER //
// ./src/Components/Pages/Password.js